/* @flow */


import {
  getReferrer,
  getPageUrl,
  isJSONSupported,
  JSONParse
} from '../utils/browserutil';
import { getFromStore, saveToStore } from '../utils/storageutils';
import { fetchJSON, isFetchSupported } from '../utils/fetch';
import getCVars from '../utils/gputils';
import _idpbase from './idpbase';
import { IDP_FABRICK } from './idpconstants';

// to be consistent with prebid.js and others can pick it up as well.
const FABRICK_COOKIE_NAME = 'pbjs_fabrickId';
/**
 * stored in cookie as an object
 * {fabrickId}
 */

class _fabrickidp extends _idpbase {
  _idRequested: boolean;

  constructor(name: string) {
    super(name);
    this._idRequested = false;
  }

  _loadFromCache(): boolean {
    if (this._cachedID.length > 0) {
      return true;
    }

    const cookieVal = getFromStore(FABRICK_COOKIE_NAME, this._storage);
    if (cookieVal.length === 0) {
      return false;
    }
    const { fabrickId = '' } = JSONParse(cookieVal, 'fabrickidp') || {};
    this._cachedID = fabrickId;
    if (this._cachedID.length > 0 && this._idUpdateTime === 0) {
      this._idUpdateTime = Date.now();
    }
    return this._cachedID.length > 0;
  }

  _saveToCookie(fabrickId: string) {
    this._cachedID = fabrickId;
    const cookieObj = {
      fabrickId
    };
    saveToStore(
      {
        name: FABRICK_COOKIE_NAME,
        value: JSON.stringify(cookieObj),
        doc: this._doc,
        expires: this._nExpireDays * 24 * 60 * 60
      },
      this._refreshInterval > 0,
      this._storage
    );
  }

  _isSupported(): boolean {
    return super._isSupported() && isFetchSupported() && isJSONSupported();
  }

  _fetchFromServer() {
    if (this._url.length === 0 || this._pid.length === 0 || this._idRequested) {
      return;
    }

    this._idRequested = true;
    // get SHA1 email
    const { _uh: sha1Email = '' } = getCVars();

    // eslint-disable-next-line promise/catch-or-return
    fetchJSON(
      this._url,
      {
        data: {
          apiKey: this._pid,
          u: getPageUrl(),
          f: getReferrer(),
          e: sha1Email
        },
        logPrefix: IDP_FABRICK,
        timeout: 2000
      },
      { credentials: 'include', mode: 'cors' }
    )
      .then((res: fabrickResponse) => {
        const { fabrickId } = res;
        this._saveToCookie(fabrickId);
        this._cachedID = fabrickId;
        return fabrickId;
      })
      .finally(() => {
        this._idRequested = false;
      });
  }

  _refreshID() {
    // get from fabrick server and cache
    // not wait for it though
    this._fetchFromServer();
  }
}

const fabrickidp: _fabrickidp = new _fabrickidp(IDP_FABRICK);
export default fabrickidp;
